import React, { useState } from "react";
import Table from "components/TableComp";
import { Button, Card, Form } from "react-bootstrap";
import { ConfirmAlert } from "components";

export interface IAlvo {
  id? : number| string
  nome: string;
}

interface IColunaTabela {
  row: any;
  deleteFn?: (rowId: number | string) => void;
  editFn?: (alvo: IAlvo) => void;
}

export function ColunaAction({
  row,
  deleteFn,
  editFn,
}: IColunaTabela) {
  const alvo: IAlvo = {
    id: row.original.id,
    nome: row.original.nome,
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        gap: "8px",
      }}
    >
      {/* <span
        className="action-icon"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          editFn?.(alvo);
        }}
        title="Editar"
      >
        <i className="mdi mdi-square-edit-outline" />
      </span> */}

      <ConfirmAlert
        text={`Excluir o item "${row.original.nome}"?`}
        cb={() => deleteFn?.(row.original.id)}
      >
        <span
          style={{
            cursor: "pointer",
            margin: "2px",
          }}
          title="Excluir"
        >
          <i className="mdi mdi-delete" />
        </span>
      </ConfirmAlert>
    </div>
  );
}

interface IAlvoProps {
  alvos: IAlvo[];
  setAlvos: Function;
}

function AlvoInside({
  alvos,
  setAlvos,
}: IAlvoProps) {
  const [novoAlvo, setNovoAlvo] = useState("");

  const [editingAlvo, setEditingAlvo] =
    useState<IAlvo | null>(null);

  const handleCreate = () => {
    if (!novoAlvo.trim()) return;

    setAlvos((prev) => [
      ...prev,
      {
        nome: novoAlvo.trim(),
      },
    ]);

    setNovoAlvo("");
  };

  const handleEdit = () => {
    if (!editingAlvo) return;

    setAlvos((prev) =>
      prev.map((a) =>
        a.id === editingAlvo.id
          ? editingAlvo
          : a,
      ),
    );

    setEditingAlvo(null);

  };

  const handleDelete = (
    id: number | string,
  ) => {
    setAlvos((prev) =>
      prev.filter((a) => a.id !== id),
    );
  };

  const openEdit = (alvo: IAlvo) => {
    setEditingAlvo({ ...alvo });
  };

  return (
    <>
      {!editingAlvo &&
        <Card className="mb-3">
          <Card.Body>
            <Form.Group>
              <Form.Label>
                Novo alvo
              </Form.Label>

              <div className="d-flex gap-2">
                <Form.Control
                  value={novoAlvo}
                  placeholder="Digite o nome do alvo"
                  onChange={(e) =>
                    setNovoAlvo(e.target.value)
                  }
                />

                <Button
                  variant="primary"
                  onClick={handleCreate}
                >
                  Adicionar
                </Button>
              </div>
            </Form.Group>
          </Card.Body>
        </Card>  
      }

      {editingAlvo && (
        <Card className="mb-3 border-warning">
          <Card.Body>
            <Form.Group>
              <Form.Label>
                Editando alvo
              </Form.Label>

              <Form.Control
                value={editingAlvo.nome}
                onChange={(e) =>
                  setEditingAlvo({
                    ...editingAlvo,
                    nome: e.target.value,
                  })
                }
              />
            </Form.Group>

            <div className="d-flex gap-2 mt-3">
              <Button
                variant="primary"
                onClick={handleEdit}
              >
                Salvar
              </Button>

              <Button
                variant="secondary"
                onClick={() =>
                  setEditingAlvo(null)
                }
              >
                Cancelar
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="header-title mb-0">
              Alvos
            </h4>
          </div>

          <Table
            columns={[
              {
                Header: "Alvo",
                accessor: "nome",
                Cell: ({ row }: any) => (
                  <span>
                    {row.original.nome}
                  </span>
                ),
                sort: false,
              },
              {
                Header: "",
                accessor: "acoes",
                Cell: ({ row }: any) => (
                  <ColunaAction
                    row={row}
                    deleteFn={handleDelete}
                    editFn={openEdit}
                  />
                ),
              },
            ]}
            data={[...alvos].sort((a, b) =>
              a.nome.localeCompare(b.nome),
            )}
            tableClass="table-striped"
            pagination={false}
          />
        </Card.Body>
      </Card>
    </>
  );
}

export default function Alvo({
  alvos,
  setAlvos,
}: IAlvoProps){

    const [show, setShow] = useState(false)

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <div style={{
            display: "flex",
            justifyContent: "space-between"
          }}>
            <span>
              Gerenciar Alvos: {alvos.length}
            </span>
            <Button onClick={()=>{setShow(p => {return !p})}}>
              {show ? 
              <i className="mdi mdi-minus-circle" />
              : <i className="mdi mdi-plus-circle" />
              }
              
            </Button>
          </div>
        </Card.Title>
      </Card.Header>
      { show &&
      <Card.Body>
        <AlvoInside
          alvos={alvos}
          setAlvos={setAlvos}
        ></AlvoInside>
      </Card.Body>
      }

    </Card>

  )
}